<footer>
  <div class="container">
    <p>© {{currentYear}} RNE | PCS Powered by G+D Netcetera</p>
  </div>
</footer>
